import React, {useRef, useState} from "react";
import {ReactTabulator} from "react-tabulator";
import {toast} from "react-toastify";
import _axios from "../../../httpService";
import Loader from "../../Loader";
import "./FormBuilder.scss";
import {useParams} from "react-router-dom";

const FormBuilder = ({onSubmit, submitText, comeFrom}) => {
    //comeFrom  >=>  documentSaz  or normalForm
    // i will ckeck if has Params Id
    const paramId = useParams()['id'];


    const [tableData, setTableData] = useState(undefined);

    const [disableButtonStatus, setDisableButtonStatus] = useState(false);
    const [showDomainField, setShowDomainField] = useState(false);
    const [showStringField, setShowStringField] = useState(false);
    const [showRlookupField, setShowRlookupField] = useState(false);

    const [dataAfterChangeRefrenceInput, setDataAfterChangeRefrenceInput] =
        useState(-1); // 0=loading   -1= nothing <></>     1==data

    const [showRlookupSelectOptionField, setShowRlookupSelectOptionField] =
        useState(-1); // 0=loading   -1= nothing    1==data

    const tableOptions = {layout: "fitColumns", selectable: 1};

    const tableColumns = [
        {
            title: "عنوان فیلد",
            field: "name",
            headerSort: false,
        },
        {
            title: "نوع فیلد",
            field: "type",
            visible: true,
            headerSort: false,
        },
        {
            title: "مانده اولیه",
            field: "firstAmount",
            visible: paramId !== undefined,
            headerSort: false,
        },
        {
            title: "عنوان انگلیسی",
            field: "enName",
            visible: true,
            headerSort: false,
        },
        {
            title: "طول رشته",
            headerSort: false,
            field: "length"
        },
        {
            title: "دامنه",
            field: "domain",
            visible: true,
            headerSort: false,
        },
        {
            title: " مرجع",
            field: "reference",
            visible: true,
            headerSort: false,
        },
        {
            title: "نوع مرجع",
            field: "referenceType",
            visible: true,
            headerSort: false,
        },
        {
            title: "مقدار مرجع",
            field: "ref",
            visible: true,
            headerSort: false,
        },
        {
            title: " فرعی",
            field: "secondData",
            visible: true,
            headerSort: false,
        },
        {
            title: "مقدار فرعی",
            field: "refConfig",
            visible: true,
            headerSort: false,
        },
        {
            title: "حذف",
            headerSort: false,
            formatter: "buttonCross",
            width: 90,
            cellClick: function (e, cell) {
                // اینجا چیکار میکنم؟ میگیرم دیتا جدول رو کلا دوباهر میسازم و میزارم توی جدول اما سطری که کلیک شده رو حذف میکنم.
                if (cell.getRow().getData().ref !== "-") {
                    let tempTable = [];
                    // if (tableRef.current.table.getData().length > 0)
                    let tableDataPlease = tableRef.current.table.getData();

                    tableDataPlease.forEach((item) => {
                        if (
                            item.ref !== cell.getRow().getData().ref
                        ) {
                            tempTable.push(item);
                        }
                    });
                    setTableData(tempTable);
                } else {
                    cell.getRow().delete();
                }
            },
        },
    ];

    const documentFormTitleRef = useRef(null);
    const titleFieldRef = useRef(null);
    const typeFieldRef = useRef(null);
    const lengthFieldRef = useRef(null);
    const domainFieldRef = useRef(null);
    const referenceRef = useRef(null);
    const formRef = useRef(null);
    const tempRef = useRef(null); // tempRef to Add to domainFieldRef
    const defaultCheckFirstDataRef = useRef(null);
    const firstAmountRef = useRef(null);

    const [refererenceConfigHolderFirst, setRefererenceConfigHolderFirst] =
        useState([]);
    const [refererenceConfigHolderSecond, setRefererenceConfigHolderSecond] =
        useState([]);

    const tableRef = useRef([]);

    function registerForm(event) {
        event.preventDefault();

        // باید کنترل کنم که فقط یه دونه از اون فیلد ها مبلغ اولیه داشته باشه. دوتا نباشه. این درصورتیه که این فرم ساز از فرک ساز کلیه بار بشه.
        //موقعی که از فرم سند ساز میاد اصلا این مورد رو نباید چک کنم اصلا
        //So
        let hasUniqFirstValueCounter = 0;


        // میخوام مطمین بشم که حتما فیلد مبلغ داره پس یه گزینه میزارم واسه hasPrice
        // بعد توی جدول چک میکنم که مبلغ زده یا نه اگه آره اینو مقدار ترو ست میکنم و میفرستم
        let hasPrice = false;
        //من اینو نوشته بودم. اما  1401-06-09 مهندس طاهری گفت کلا نمیخواد حتما بدهکار بستناکار باشه. فقط چک کن دوتا باشه.
        // let hasbed = false;
        // let hasbes = false;


        let fetchs = [];
        let fieldData = []

        // tabulator data to fetch Array
        let tableDataPlease = tableRef.current.table.getData();
        // بریز تو این آرایه  میخوام چک کنم چند تا رفرنس داره و بعدش چک کنم تکراریه یا نه

        let refrencesValueToCheckIs2 = [];

        tableDataPlease.forEach((item) => {
            if (item.type === "مبلغ") hasPrice = true;
            // if (item.referenceType === 'bed') hasbed = true;
            // if (item.referenceType === 'bes') hasbes = true;

            if (item.firstAmount === "1") hasUniqFirstValueCounter++;

            let arrayDomain = item.domain.split("|");
            if (arrayDomain.length > 0) arrayDomain.pop();
            //console.log(arrayDomain);
            //debugger
            //typeof(item.refConfig.split(",").pop())==='object' ? item.refConfig.split(",").pop() : [],
            let refConfigTemp = item.refConfig.split(",");

            if (refConfigTemp.length > 0) {
                let RemovedRefConfigTemp = refConfigTemp.pop();
            }

            refrencesValueToCheckIs2.push({reference: item.reference});
            fieldData.push({
                name: item.name,
                type: item.type,
                firstAmount: item.firstAmount,
                enName: item.enName,
                length: item.length,
                domain: arrayDomain,
                reference: item.reference,
                referenceType: item.referenceType,
                ref: item.ref,
                secondData: item.secondData,
                refConfig: refConfigTemp,
            });
        });


        fetchs.push({"fieldData": fieldData})


        // مهندس گفت باید حداقل یه فیلد بدهکار بستانکار داشته باشه
        // ممکنه که توی فرم ساز دیکه ای اینو نخواد پس اینو میزارم و احتمالا یه شرط بزارم واسش که اگه فلان پراپز بود اینو هم چک کن اگه نبود چک نکن
        if (comeFrom === "documentSaz") {
            //debugger
            // اگه از طرف فرم ساز بود دارم یک عنوان اضافه میکنم. خب پس مطمئن میشم که عنوان رو وارد کرده و بعدش
            // عنوان رو اضافه میکنم به انتتی دیتا
            if (documentFormTitleRef.current.value.length < 3) {
                if(documentFormTitleRef.current.value.length=== 0){
                    toast.error("لطفا یک  عنوان برای فرم وارد کنید.");
                    throw new Error("لطفا یک  عنوان برای فرم وارد کنید.");
                }
                toast.error("لطفا یک عنوان مناسب برای فرم وارد کنید.");
                throw new Error("لطفا یک عنوان مناسب برای فرم وارد کنید.");
            }

            // if (!hasbed) {
            //     toast.error("حداقل یک فیلد مرتبط به بدهکار الزامی است.")
            //     return;
            // }
            // if (!hasbes) {
            //     toast.error("حداقل یک فیلد مرتبط بستانکار الزامی است.");
            //     return;
            // }

            // اینجا میام همه ی مرجع ها رو که ریختم روی یه آرایه تکراری هاشو حذف میکنم. بعدش  مطمئن میشم که حداقل دوتا باشه
            // ضمنا باید چک کنم که خط تیره رو در نظر نگیره.
            let uniqueArray = refrencesValueToCheckIs2.filter((value, index) => {
                const _value = JSON.stringify(value);
                return index === refrencesValueToCheckIs2.findIndex(obj => {
                    return JSON.stringify(obj) === _value;
                });
            });

            uniqueArray = uniqueArray.filter(v => v.reference !== "-");

            if (uniqueArray.length < 2) {
                toast.error("حداقل از دو مرجع باید سطر اتصال به سایر در جدول اضافه کنید.");
                return;
            }
            // add entityData
            fetchs.push({entityData: {type: "sn", name: documentFormTitleRef.current.value}})
        } else {
            if (hasUniqFirstValueCounter > 1) {
                toast.error("بیش از یک مقدار برای مبلغ اولیه ست شده است.");
                return;
            }

            fetchs.push({entityData: {type: "dt", id: paramId}})
        }


        console.log("i am Awesome Log");
        console.log(fetchs)
        hasPrice ? onSubmit(fetchs) : toast.error("حداقل یک فیلد مبلغ الزامی است.");


    }

    function resetForm() {
        setShowCheckBox(false);
        // اینجا اون استیتی که چک شده ها رو نگه داشته باید خالی بشه
        setRefererenceConfigHolderSecond([]);
        setRefererenceConfigHolderFirst([]);
        if (titleFieldRef.current !== null) titleFieldRef.current.value = "";

        typeFieldRef.current.value = "0";
        setShowRlookupField(false);
        setShowDomainField(false);
        setShowStringField(false);

        if (lengthFieldRef.current !== null) lengthFieldRef.current.value = "";
        if (domainFieldRef.current !== null)
            domainFieldRef.current.innerHTML = emptyMsg;
    }

    function addRow(event) {
        event.preventDefault();

        let tempDataTabulator = [];
        let tableDataPlease = tableRef.current.table.getData();

        // اگه فیلد اتصال به سایر بود متد ورود اطلاعات به جدول یکم فرق داره. که بک اینجوری میخواد.
        if (typeFieldRef.current.value === "6") {
            const temp = referenceRef.current.value
            if (temp === "0") {
                toast.error("لطفا یک مرجع انتخاب کنید.");
                throw new Error("لطفا یک مرجع انتخاب کنید.");
            }
            //اینجا باید به تعداد مقادیر سمت راست به جدول یه چیزایی اضافه کنم
            const fullCheckedOptions = refererenceConfigHolderFirst;

            //       add Default checked input
            fullCheckedOptions.push({
                name: defaultCheckFirstDataRef.current.name,
                value: defaultCheckFirstDataRef.current.value,
                // ref: referenceRef.current.value,
            });

            // مقادیر سمت چپ رو هم بگیرم توی یه آرایه که به ازای هر سمت راستی اینو بزارم تو جدول
            const LeftSideKeyValues = refererenceConfigHolderSecond;
            // اینجا مهندس طاهری گفت باید حتما حداقل یه دونه رو از فیلد سمت چپ انتخاب کنه. من ممیگم چشم و چک میکنم
            if (LeftSideKeyValues.length === 0) {
                toast.error("از جدول سمت چپ هیچ تیکی زده نشده.");
                throw new Error("از جدول سمت چپ هیچ تیکی زده نشده.");
            }
            let tempSecondDataText = "";
            let tempSecondDataValues = "";
            for (let v of LeftSideKeyValues) {
                tempSecondDataValues += v.value + ",";
                tempSecondDataText += v.name + ", ";
            }
            let objectToAdd = {};
            let tempTableDataPlease = tableDataPlease;

            // چون توی حالتی که میخواد آرلولاپی باشه در اتصال به سایر نمیتونم دقیق چک کنم که آیا عنوان تکراریه یا نه
            // همیخوام همینجا چک کنم که آیا کاربر عنوان تکراری زده یا نه

            // چون دارم عنوان انگلیسی میفرستم دیگه فعلا اینو چک نمیکنم وگرنه خیلی هم واجبه. والا

            //
            // for (let fullCheckedOption of fullCheckedOptions) {
            //
            //     objectToAdd = {name: fullCheckedOption.name}
            //     if (tableDataPlease.length > 0) {
            //         tableDataPlease.map(v => {
            //             // مهندس طاهری گفت عنوان ها هم تکراری نباشه منم اینجا اینو جلوش میگیرم
            //             if (v.name === objectToAdd.name) {
            //                 toast.error("عنوان فیلد تکراری است.");
            //                 throw new Error("عنوان فیلد تکراری است.");
            //             }
            //         });
            //     }
            //
            // }

            // فعلا موقتی مهندس طاهری گفت اگه از اون مرجعه بود بگو دیگه اضافه نکن.
            for (let fullCheckedOption of fullCheckedOptions) {
                objectToAdd = {
                    name: fullCheckedOption.name,
                    ref: referenceRef.current.value.split("__________")[0],
                };

                if (tableDataPlease.length > 0) {
                    // مهندس طاهری گفت عنوان ها هم تکراری نباشه منم اینجا اینو جلوش میگیرم

                    tableDataPlease.map((v) => {
                        if (v.ref !== "-") {
                            if (v.ref === objectToAdd.ref) {
                                toast.error("مرجع تکراری است.");
                                throw new Error(" مرجع  تکراری است.");
                            }
                        }

                    });
                }
            }


            for (let v of fullCheckedOptions.reverse()) {
                objectToAdd = {
                    name: v.name,
                    type: typeFieldRef.current.options[typeFieldRef.current.selectedIndex]
                        .text,
                    firstAmount: "-",
                    enName: v.value,
                    length: "-",
                    domain: "-",
                    reference: referenceRef.current
                        ? referenceRef.current.options[referenceRef.current.selectedIndex]
                            .text
                        : "-",
                    ref: referenceRef.current
                        ? referenceRef.current.value.split("__________")[0]
                        : "-",
                    referenceType: referenceRef.current
                        ? referenceRef.current.value.split("__________")[1]
                        : "-",
                    secondData: tempSecondDataText,
                    refConfig: tempSecondDataValues,
                };
                //debugger;
                // فقط به این خاطر باید اگه بزرگتر از صفر بودن رو چک کنم که اگه
                // کاربر داده ی تکراری بخواد وارد کنه جلوشو بگیرم. چون قرارمون اینه
                // ولی توی قبلی ها اگه بزرگتر از صفر بود میریختم توی متغیر موقتی و ازش استفاده میکردم.
                // if (tempTableDataPlease.length > 0) {
                //     tempTableDataPlease.map((value, index) => {
                //         // مهندس طاهری گفت عنوان ها هم تکراری نباشه منم اینجا اینو جلوش میگیرم
                //         if (index > indexOfIteration) {
                //             if (value.name === objectToAdd.name) {
                //                 toast.error("عنوان فیلد تکراری است.");
                //                 throw new Error("عنوان فیلد تکراری است.");
                //             }
                //         }
                //     });
                //
                //
                // }
                tempTableDataPlease.push(objectToAdd);

            }
            setTableData(tempTableDataPlease);
        } else {
            if (titleFieldRef.current) {
                if (titleFieldRef.current.value === "") {
                    toast.error("لطفا عنوان فیلد را انتخاب کنید");
                    return;
                }
            }

            if (typeFieldRef.current.value === "0") {
                toast.error("لطفا نوع  فیلد را انتخاب کنید");
                return;
            }

            let objectToAdd = {
                name: titleFieldRef.current.value,
                type: typeFieldRef.current.options[typeFieldRef.current.selectedIndex]
                    .text,
                firstAmount: firstAmountRef.current ? firstAmountRef.current.checked ? "1" : "0" : "-",
                enName: "-",
                length: lengthFieldRef.current ? lengthFieldRef.current.value : "-",
                domain: domainFieldRef.current ? domainFieldRef.current.innerHTML : "-",
                reference: referenceRef.current
                    ? referenceRef.current.options[referenceRef.current.selectedIndex]
                        .text
                    : "-",
                referenceType: "-",
                ref: referenceRef.current ? referenceRef.current.value : "-",
                secondData: "-",
                refConfig: "-",
            };

            if (lengthFieldRef.current) {
                if (lengthFieldRef.current.value === "") {
                    toast.error("لطفا طول رشته را انتخاب کنید");
                    return;
                }
            }

            if (domainFieldRef.current) {
                if (
                    domainFieldRef.current.innerHTML === emptyMsg ||
                    domainFieldRef.current.innerHTML === ""
                ) {
                    toast.error("لطفا دامنه را وارد کنید.");
                    return;
                }
            }
            //End Check inputs
            console.log(objectToAdd);

            if (tableDataPlease.length > 0) {
                tableDataPlease.map((v) => {
                    // مهندس طاهری گفت عنوان ها هم تکراری نباشه منم اینجا اینو جلوش میگیرم
                    if (v.name === objectToAdd.name) {
                        toast.error("عنوان فیلد تکراری است.");
                        throw new Error("عنوان فیلد تکراری است.");
                    }
                    // اگه تکراری بود میشه لطفا اجازه ندی به جدول اضافه بشه؟
                    if (JSON.stringify(v) === JSON.stringify(objectToAdd)) {
                        toast.error("این مورد قبلا به جدول اضافه شده است.");
                        throw new Error("این مورد قبلا به جدول اضافه شده است.");
                    }
                    tempDataTabulator.push({
                        name: v.name,
                        type: v.type,
                        firstAmount: v.firstAmount,
                        enName: v.enName,
                        length: v.length,
                        domain: v.domain,
                        reference: v.reference,
                        referenceType: v.referenceType,
                        ref: v.ref,
                        secondData: v.secondData,
                        refConfig: v.refConfig,
                    });
                });
                tempDataTabulator.push(objectToAdd);
            } else {
                tempDataTabulator.push(objectToAdd);
            }
            setTableData(tempDataTabulator);
        }

        resetForm();
        // formRef.current.reset();
    }

    const [showCheckBox, setShowCheckBox] = useState(false)
    const typeFieldOnChange = (event) => {
        setShowCheckBox(false);
        setDataAfterChangeRefrenceInput(-1);

        if (typeFieldRef.current.value === "3") {
            setShowCheckBox(true)

        }
        // اگه دامنه بود. فیلد دامنه رو ظاهر کن
        if (typeFieldRef.current.value === "5") {
            setShowDomainField(true);
            setShowStringField(false);
            setShowRlookupField(false);
            // اگه رشته بود فیلد طول رشته رو ظاهر کن
        } else if (typeFieldRef.current.value === "1") {
            setShowStringField(true);
            setShowDomainField(false);
            setShowRlookupField(false);
            // اگه اتصال به دامنه رو انتخاب کرد فیلد مرجع رو نشون بده. اما میخوایم بگیم آقای بک لطفا اصلاعات بفرست
            // تا توی  سلکت آپشن هاش نشون بدیم.
        } else if (typeFieldRef.current.value === "6") {
            setShowStringField(false);
            setShowDomainField(false);

            setShowRlookupSelectOptionField(0);
            // وقتی داره لود میشه تنا وقتی جواب از بک نیومده باید دکمه غیر فعال باشه تا اشتباهی چیزی توی جدول اضافه نکنه.
            setDisableButtonStatus(true);
            _axios.get(`${localStorage.getItem("apiUrl2")}w/loe/`).then((res) => {
                setShowRlookupSelectOptionField(res.data);
                setDisableButtonStatus(false);
            });
            // اگه فیلد مرجع بود عنوان فیلد رو نشون نمیدم چون کلا با یه ساختار دیگه ای دارم به جدول اطلاعات اضافه میکنم.
            setShowRlookupField(true);
        } else {
            setShowStringField(false);
            setShowDomainField(false);
            setShowRlookupField(false);
        }
    };
    let emptyMsg = "دامنه ها خالی هستند.";

    const addOptionToList = () => {
        if (tempRef.current) {
            if (tempRef.current.value === "") {
                console.log("tempRef.current=" + tempRef.current);
                toast.error("لطفا یک مقدار وارد کنید.");
                return;
            }
            domainFieldRef.current.innerHTML =
                domainFieldRef.current.innerHTML.replace(emptyMsg, "");
            domainFieldRef.current.innerHTML += "" + tempRef.current.value + "|";
            tempRef.current.value = "";
        } else {
            console.log("tempRef.current=" + tempRef.current);
            toast.error("لطفا یک مقدار وارد کنید.");
        }
    };
    const deleteDomains = () => {
        if (domainFieldRef.current) domainFieldRef.current.innerHTML = "";
        else console.log("domainFieldRef.current==" + domainFieldRef.current);
    };

    // اینجا متناسب با مقدار ورودی که کاربر زده باید زیرش دو تا جدول چک باکسی  نشون بدم که بک اطلاعات اون جداول میاد
    // متناسب با اطلاعات دریافتی یه استیت رو میزارم که به کاربرم اطلاعات رو نشون بده.
    function referenceOnChangeShow(event) {
        let value = event.target.value;
        console.log(event.target.value);
        value = value.split("__________")[0]
        //
        setDataAfterChangeRefrenceInput(0);
        _axios.get(`${localStorage.getItem("apiUrl2")}w/lof/?key=` + value).then((res) => {
            // console.log(res.data)
            setDataAfterChangeRefrenceInput(res.data);
        });
        // اینجا هم باید این دو تا رو خالی کنم. ممکنه وسط کار دو تا تیک بزنه بعد بیاد فقط این سلکت آپشن رو عوض کنه باید تیک های قبلی کلا از توی استیت پاک بشن
        setRefererenceConfigHolderSecond([]);
        setRefererenceConfigHolderFirst([]);
    }

    function firstDataHandler(event) {
        //we Must Add Default Checked Input On Click Not Here

        const tempValue = {name: event.target.name, value: event.target.value};
        let tempStateArray = refererenceConfigHolderFirst;

        if (event.target.checked) {
            tempStateArray.push(tempValue);
            console.log(tempStateArray);
            setRefererenceConfigHolderFirst(tempStateArray);
        } else {
            // return;
            // let temp = delete refererenceConfigHolderFirst.event.target.value;

            const result = tempStateArray.filter((v) => {
                return JSON.stringify(v) !== JSON.stringify(tempValue);
            });
            console.log("result");
            console.log(result);
            setRefererenceConfigHolderFirst(result);
        }
    }

    function secondDataHandler(event) {
        const tempValueSecondDataHandler = {
            name: event.target.name,
            value: event.target.value,
        };
        let tempStateArray = refererenceConfigHolderSecond;

        if (event.target.checked) {
            tempStateArray.push(tempValueSecondDataHandler);
            console.log(tempStateArray);
            setRefererenceConfigHolderSecond(tempStateArray);
        } else {
            const resultSecondDataHandler = tempStateArray.filter((v) => {
                return JSON.stringify(v) !== JSON.stringify(tempValueSecondDataHandler);
            });
            console.log("resultSecondDataHandler");
            console.log(resultSecondDataHandler);
            setRefererenceConfigHolderSecond(resultSecondDataHandler);
        }
    }

    return (
        <form className="form-builder" ref={formRef}>
            <div className="form-builder__container my-4 ">
                <div>
                    {comeFrom === "documentSaz" ?
                        <>
                            {/*باید فیلد نام نمایش بدم و موقع ارسال اطلاعات باید*/}
                            {/*entityData:{ type:"sn" , name:"FORM_NAME"}*/}
                            <div className="selectWidthComplete">
                                <label htmlFor="InputName" className="control-lable form-label">
                                    عنوان فرم
                                </label>
                                <input
                                    ref={documentFormTitleRef}
                                    type="text"
                                    className="form-control inputBox"
                                    // name=""
                                    // defaultValue=""
                                    autoComplete="off"
                                    // maxLength='11'
                                    placeholder="لطفا عنوان فرم را وارد کنید..."
                                />
                                <label className="error-msg"></label>
                            </div>

                        </>
                        :
                        <>
                            {/* باید موقع ارسال اطلاعات  آیدی بزارم*/}
                            {/*entityData:{ type:"dt" , id:"همون حساب معینی که روش کلیک کرده- که از پارامز میاد"}*/}
                        </>
                    }
                    <div className="selectBox">
                        <div className="selectBox-sides">
                            <label htmlFor="InputName" className="control-lable form-label">
                                نوع فیلد
                            </label>
                            <select
                                ref={typeFieldRef}
                                className="form-control inputBox"
                                name=""
                                // value={typeFieldRef.current.value}
                                defaultValue="0"
                                placeholder="متن مورد نظر خود را وارد کنید"
                                onChange={typeFieldOnChange}
                            >
                                <option value="0" hidden={true}>
                                    انتخاب کنید
                                </option>
                                <option value="1">رشته اي</option>
                                <option value="2">عددي</option>
                                <option value="3">مبلغ</option>
                                <option value="4">اعشاري</option>
                                <option value="5">دامنه دار</option>
                                <option value="6">اتصال به سایر</option>
                                <option value="7">تاریخ</option>
                                <option value="8">ساعت</option>
                            </select>
                            <label className="error-msg"></label>
                        </div>


                        {!showRlookupField && (
                            <div className="selectBox-sides">
                                <label htmlFor="InputName" className="control-lable form-label">
                                    عنوان فیلد
                                </label>
                                <input
                                    ref={titleFieldRef}
                                    type="text"
                                    className="form-control inputBox"
                                    name=""
                                    defaultValue=""
                                    autoComplete="off"
                                    // maxLength='11'
                                    placeholder="متن مورد نظر خود را وارد کنید"
                                />
                                <label className="error-msg"></label>
                            </div>


                        )}


                    </div>

                    {paramId !== undefined && showCheckBox && (
                        <div className="" style={{"direction": "ltr"}}>
                            <label htmlFor="InputNameCheckboxMoney" className=""> مانده اول دوره
                            </label>
                            <input
                                ref={firstAmountRef}
                                type="checkbox"
                                name=""
                                id={"InputNameCheckboxMoney"}
                            />
                        </div>
                    )}


                    {showStringField && (
                        <div className="selectBox">
                            <div className="selectBox-sides">
                                <label htmlFor="InputName" className="control-lable form-label">
                                    طول رشته
                                </label>
                                <input
                                    ref={lengthFieldRef}
                                    type="number"
                                    // pattern="\d*"
                                    pattern="[0-9]"
                                    min={1}
                                    maxLength="11"
                                    className="form-control inputBox"
                                    name=""
                                    defaultValue=""
                                    autoComplete="off"
                                    placeholder="متن مورد نظر خود را وارد کنید"
                                    required
                                />
                                <label className="error-msg"></label>
                            </div>
                        </div>
                    )}
                    {showDomainField && (
                        <div className="selectBox-sides">
                            <label htmlFor="InputName" className="control-lable form-label">
                                دامنه
                            </label>
                            <div style={{position: "relative"}}>
                                <input
                                    // style={{"position":"absolute"}}
                                    ref={tempRef}
                                    type="text"
                                    className="form-control inputBox"
                                    id=""
                                    name=""
                                    defaultValue={""}
                                    autoComplete="off"
                                    // maxLength='11'
                                    placeholder="با فشردن کلید اینتر به لیست دامنه ها اضافه کنید"
                                    onKeyDown={(e) => {
                                        e.key === "Enter" && addOptionToList();
                                    }}
                                    required
                                />
                                <span
                                    style={{
                                        position: "absolute",
                                        top: "8px",
                                        left: "37px",
                                        fontSize: "11px",
                                    }}
                                    className="btn btn-domain"
                                    onClick={addOptionToList}
                                    ref={domainFieldRef}
                                >
                  <i className="fas fa-plus"></i>
                </span>
                                <span
                                    style={{
                                        position: "absolute",
                                        top: "8px",
                                        left: "8px",
                                        fontSize: "11px",
                                    }}
                                    className="btn btn-domain"
                                    onClick={deleteDomains}
                                >
                  <i className="fas fa-minus"></i>
                </span>
                            </div>

                            <label ref={domainFieldRef} className="error-msg">
                                {emptyMsg}
                            </label>
                        </div>
                    )}

                    {showRlookupField ? (
                        showRlookupSelectOptionField === 0 ? (
                            <Loader/>
                        ) : showRlookupSelectOptionField === 1 ? (
                            <></>
                        ) : (
                            <div className="selectWidthComplete">
                                <label htmlFor="InputName" className="control-lable form-label">
                                    مرجع
                                </label>

                                <select
                                    ref={referenceRef}
                                    className="form-control inputBox"
                                    name=""
                                    defaultValue="0"
                                    placeholder="فیلد مرجع را انتخاب کنید"
                                    onChange={referenceOnChangeShow}
                                >
                                    <option value="0" hidden={true}>
                                        انتخاب کنید
                                    </option>
                                    {showRlookupSelectOptionField.map &&
                                        showRlookupSelectOptionField.map((v) => (

                                            <option key={v.key} value={v.key + "__________" + v.type}>
                                                {v.name}
                                            </option>
                                        ))}
                                </select>
                                <label className="error-msg"></label>
                                {/*  حالا اینجا میایم و اون یه موردی که روی تغییرش ریکوئست زدیم به بک رو نشون به کاربر میدیم.  */}
                                {dataAfterChangeRefrenceInput === 0 ? (
                                    <Loader/>
                                ) : dataAfterChangeRefrenceInput === -1 ? (
                                    <></>
                                ) : (
                                    <div className={"rlookup-fields-container "}>
                                        <div>
                                            {dataAfterChangeRefrenceInput.map((v) => (
                                                <>
                                                    {v.essential === "1" ? (
                                                        <div className="CheckBOX">
                                                            <input
                                                                ref={defaultCheckFirstDataRef}
                                                                onChange={firstDataHandler}
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                value={v.key}
                                                                id={v.key}
                                                                name={v.name}
                                                                checked={true}
                                                                disabled={true}
                                                            />
                                                            <label className="" htmlFor={v.key}>
                                                                {v.name}
                                                            </label>
                                                        </div>
                                                    ) : (
                                                        <div className="CheckBOX">
                                                            <input
                                                                onChange={firstDataHandler}
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                value={v.key}
                                                                id={v.key}
                                                                name={v.name}
                                                            />
                                                            <label className="" htmlFor={v.key}>
                                                                {v.name}
                                                            </label>
                                                        </div>
                                                    )}
                                                </>
                                            ))}
                                        </div>

                                        <div>
                                            {dataAfterChangeRefrenceInput.map((v) => (
                                                <>
                                                    {/*<div> {v.name}- {v.key}  </div>*/}

                                                    <div className="CheckBOX">
                                                        <input
                                                            onChange={secondDataHandler}
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value={v.key}
                                                            name={v.name}
                                                            id={v.key + "2"}
                                                        />
                                                        <label className="" htmlFor={v.key + "2"}>
                                                            {v.name}
                                                        </label>
                                                    </div>
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/*    */}
                            </div>
                        )
                    ) : null}
                </div>

                <button
                    onClick={addRow}
                    className={"btn add-row-btn"}
                    disabled={disableButtonStatus}
                >
                    افزودن به لیست
                </button>
                <div className="form-builder-fields">
                    <div> فیلد ها</div>
                    <ReactTabulator
                        ref={tableRef}
                        columns={tableColumns ? tableColumns : null}
                        data={tableData === undefined ? [] : tableData}
                        options={tableOptions}
                    />
                </div>

                <div className="button-box mx-auto my-3 twoBtn w-100 text-center ">
                    <button type="button" className=" btn-cancel">
                        انصراف
                    </button>
                    <button
                        onClick={registerForm}
                        type="submit"
                        className={"btn btn-primary my-4"}
                    >
                        ثبت
                    </button>
                </div>
            </div>
        </form>
    );
};

export default FormBuilder;
